import { ArrowCircleLeft, ArrowCircleRight } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import React from "react";
import ImageGallery from "react-image-gallery";
import { localFileUrl } from "utils";

const ImageGalleryComponent = ({ data }) => {
  return (
    <ImageGallery
      items={data.images.map(({ fid, original, thumbnail }) => ({ fid, original: localFileUrl(original), thumbnail: localFileUrl(thumbnail) }))}
      showNav={true}
      thumbnailPosition={"bottom"}
      showPlayButton={false}
      // change nav button to mui icon buttons and show buttons only on hover on image
      renderLeftNav={(onClick, disabled) => (
        <IconButton
          size="large"
          onClick={onClick}
          disabled={disabled}
          className="absolute top-[45%] left-0 transform z-10"
        >
          {/* mui left navigation icon */}
          <ArrowCircleLeft className="text-gray-300/90 w-8 h-8" />
        </IconButton>
      )}
      renderRightNav={(onClick, disabled) => (
        <IconButton
          size="large"
          onClick={onClick}
          disabled={disabled}
          className="absolute top-[45%] right-0 transform z-10"
        >
          {/* mui right navigation icon */}
          <ArrowCircleRight className="text-gray-300/90 w-8 h-8" />
        </IconButton>
      )}
    />
  );
};

export default ImageGalleryComponent;
